import React from 'react'
import clsx from 'clsx'
import Button from '../Button/Button'
import Heading from '../Heading/Heading'
import { Link } from 'gatsby'
export const Cta = ({ otherClasses, toggleFunc }) => {
  const ctaClasses = clsx(otherClasses, 'w-full bg-black ')

  return (
    <div className={ctaClasses} data-testid="cta">
      <div className="pt-[124px] pb-[80px] px-[16px] xl:py-[192px] mx-auto max-w-[1512px] ">
        <div className="flex w-full   flex-col xl:max-w-[704px] mx-auto justify-center text-center items-center gap-4">
          <Heading
            type="h2"
            className="text-[42px] lg:text-[52px] font-extrabold text-center font-Poppins leading-[80px] lg:leading-[120px] text-[#DED7C7]"
          >
            Your Vision, Our Passion
          </Heading>
          <div className="flex flex-col gap-8">
            <p className="text-[14px] font-bold	text-center font-Mulish uppercase tracking-[0.42px] leading-[18px] text-[#DED7C7]">
              For body art at a higher standard, turn to Bay Ink Tattoo.
            </p>
            <div className="flex gap-4 justify-center items-center">
              <Link to="/book-an-appointment/">
                <Button
                  variant="secondary"
                  otherClasses="w-[150px] h-[70px]  lg:h-[48px] lg:w-auto px-0 lg:px-6 sm:w-full block whitespace-normal"
                  label="Request an Appointment"
                />
              </Link>

              <Button
                variant="secondary"
                otherClasses="w-[150px] h-[70px] lg:h-[48px] lg:w-auto px-3 lg:px-6 sm:w-full block whitespace-normal"
                label="Contact Our Parlor"
                onClick={() => toggleFunc('Contact Us')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cta
